
define('modules/application/wizard/classes/touchScreen',[
    "app",

    // Libs
    "backbone",

    // Classes
    "./genericCollectionSection"

  ],

  function(app, Backbone, genericCollectionSection) {
    var eventsToBind = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
    var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {
      View: genericCollectionSection.genericCollectionItem.View.extend({
        tagName: "li",
        className: "touchScreen",
        template: "application/wizard/sections/genericCollectionSection/touchScreen",
        events: _.extend(eventsToBind, {
          "change .type": "typeChangedEventHandler",
          "change .accessory": "accessoryChangedEventHandler",
          "keyup input[name='description']": "descriptionChangedEventHandler"
        }),
        initialize: function() {

          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          this.model.unbind("change:number", this.render);
          this.model.bind("change:number", this.render, this);
        },
        typeChangedEventHandler: function(e) {
          var typePackageClassId = e.currentTarget.value;

          //Update the model
          this.model.set("type", typePackageClassId);
        },
        accessoryChangedEventHandler: function(e) {
          if (e.currentTarget.value) {
            var accessoryPackageClassId = e.currentTarget.value;

            //Update the model
            this.model.setAccessory(accessoryPackageClassId);
          }
        },
        descriptionChangedEventHandler: function(e) {
          this.model.set("description", e.currentTarget.value);
        },
        afterRender: function() {
          this.$el.find("select").removeAttr("rel");
          window.customizeFormElements.call();
        }
      }),
      Model: genericCollectionSection.genericCollectionItem.Model.extend({
        defaults: {
          number: -1,
          filterId: -1,
          selected: false,
          description: ""
        },

        initialize: function() {
          genericCollectionSection.genericCollectionItem.Model.prototype.initialize.apply(this);
          this.bind("change:type", this.typeChangedEventHandler, this);
          this.bind("change:selfRegulated", this.selfRegulatedChangedEventHandler, this);

          this.fetchPackages();
          if (!this.get("packageClassId"))
            this.set("type", this.getFetchedPackages()[0].packageClassId);
          else
            this.set("type", this.get("packageClassId"));
          this.typeChangedEventHandler();

          this.fetchAccessories();
          if (this.get("accessory"))
            this.setAccessory(this.get("accessory").packageClassId);
        },

        getFetchedPackages: function() {
          var fetchedPackages = this.get("fetchedPackages");
          var currentFilter = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

          //if (currentFilter===4)
          //  fetchedPackages = _.filter(fetchedPackages, function(currentPackage){
          //    return currentPackage.packageClassId!=='6144';
          //  });

          return fetchedPackages;
        },

        selectedStatusChangedEventHandler: function() {
          if (this.get("selected"))
            this.get("collectionEventAggregator").trigger("selectedItem:changed", this);
          this.trigger("render:requested");
        },

        typeChangedEventHandler: function() {
          var type = this.get("type"),
            that = this;

          //Merging with wizard package attributes
          var wizardAttributes = _.filter(that.getFetchedPackages(), function(pack) {
            return pack.packageClassId === type;
          });

          if (wizardAttributes.length === 1)
            wizardAttributes = wizardAttributes[0];
          _.extend(this.attributes, wizardAttributes);

          //Merging with item's attributes
          if ((type) && (type !== "")) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(type, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);

              var mainProduct = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              })[0];
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });

              _.extend(that.attributes, mainProduct);

              that.set("secondaryProducts", secondaryProducts);

              var specialVars = that.get("specialVars") ? JSON.parse(that.get("specialVars")) : {};
              that.set("specialVars", specialVars);
              that.set("accessoriesIdWizardChoice", specialVars.accessoriesIdWizardChoice);

              if (specialVars.gotAccessories)
                that.retrieveAccessories();
              else {
                that.set("fetchedAccessories", []);
                that.set("accessory", undefined);
              }
            });
          } else {
            this.resetValues();
          }

          that.trigger("render:requested");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },

        getAccessoryDetails: function(packageClassId) {
          var accessory = _.extend({}, this.get("accessory")),
            that = this;
          if (packageClassId) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              data.products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });
              data = data.products[0];

              if (accessory instanceof Object)
                _.extend(accessory, data);
              else
                accessory = data;

              accessory.secondaryProducts = secondaryProducts;
              that.set("accessory", accessory);
            });
          }
        },

        setAccessory: function(packageClassId) {
          var accessory = this.get("accessory"),
            that = this;

          //Merging with wizard package attributes
          var wizardAttributes = _.filter(that.get("fetchedAccessories"), function(pack) {
            return pack.packageClassId === packageClassId;
          });

          if (wizardAttributes.length > 0)
            wizardAttributes = wizardAttributes[0];

          accessory = wizardAttributes;
          this.set("accessory", accessory);
          this.getAccessoryDetails(accessory.packageClassId);
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          this.trigger("render:requested");
        },

        fetchAccessories: function() {
          var that = this,
            fetchedAccessories = [];
          if (this.get("accessoriesIdWizardChoice"))
            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(that.get("accessoriesIdWizardChoice"), function(data) {
              fetchedAccessories = data.packages;
            });

          if (fetchedAccessories.length === 0)
            this.set("accessory", undefined);

          this.set("fetchedAccessories", fetchedAccessories);
        },

        retrieveAccessories: function() {
          var actualAccessoryPackageClassId = this.get("accessory");
          this.fetchAccessories();

          if (!actualAccessoryPackageClassId) {
            this.setAccessory(this.get("fetchedAccessories")[0].packageClassId);
          } else {
            if (_.filter(this.get("fetchedAccessories"), function(accessory) {
              return accessory.packageClassId === actualAccessoryPackageClassId.packageClassId;
            }).length === 0) {
              this.setAccessory(this.get("fetchedAccessories")[0].packageClassId);
            }
          }

          this.trigger("render:requested");
        },

        resetValues: function() {
          this.set("catalogId", undefined);
          this.set("description", undefined);
          this.set("image", undefined);
          this.set("links", undefined);
          this.set("mnemonic", undefined);
          this.set("optionalPackages", undefined);
          this.set("packageActuator", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
          this.set("packageInDepth", undefined);
          this.set("packageLoad", undefined);
          this.set("price", undefined);
          this.set("productCode", undefined);
          this.set("productDescription", undefined);
          this.set("productInDepth", undefined);
          this.set("productLabel", undefined);
          this.set("specialVars", undefined);
          this.set("wizardChoiceDescription", undefined);
          this.set("wizardChoiceLabel", undefined);
          this.set("packageClassDescription", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
        },

        fetchPackages: function() {
          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            var that = this;
            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(633, function(data) {
              that.set("fetchedPackages", data.packages);
            });
          }
        },

        deliverCurrent: function() {
          var mainProductSpecialVars,
            accessorySpecialVars;

          //Helper method for consumption send
          var sendConsumption = function(consumption) {
            if (consumption) {
              var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

              if (consumption < 0) {
                consumptionIndicatorModel.addConversationSupplyCurrent(consumption);
                consumptionIndicatorModel.addSoundDiffusionSupplyCurrent(consumption);
              } else {
                consumptionIndicatorModel.addConversationCurrentConsumption(consumption);
                consumptionIndicatorModel.addSoundDiffusionCurrentConsumption(consumption);
              }
            }
          };

          if (this.get("specialVars") && this.get("specialVars").currentConsumption) {

            if (!(this.get("specialVars") instanceof Object))
              this.attributes.specialVars = JSON.parse(this.attributes.specialVars);

            if ((this.get("specialVars").consumptionGroupId) && (this.get("specialVars").groupExtraConsumption)) {
              var consumptionGroupId = this.get("specialVars").consumptionGroupId.toString();
              var groupExtraConsumption = this.get("specialVars").groupExtraConsumption;
              var conversationMaxExtraConsumptions = BticinoS4B.Instances.Models.ApplicationModel.get("conversationMaxExtraConsumption");
              var soundDiffusionMaxExtraConsumptions = BticinoS4B.Instances.Models.ApplicationModel.get("soundDiffusionMaxExtraConsumption");

              if ((!conversationMaxExtraConsumptions[consumptionGroupId]) || (conversationMaxExtraConsumptions[consumptionGroupId] < groupExtraConsumption))
                conversationMaxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

              if ((!soundDiffusionMaxExtraConsumptions[consumptionGroupId]) || (soundDiffusionMaxExtraConsumptions[consumptionGroupId] < groupExtraConsumption))
                soundDiffusionMaxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

              BticinoS4B.Instances.Models.ApplicationModel.set("conversationMaxExtraConsumption", conversationMaxExtraConsumptions);
              BticinoS4B.Instances.Models.ApplicationModel.set("soundDiffusionMaxExtraConsumption", soundDiffusionMaxExtraConsumptions);
            }

            if (this.get("specialVars").currentConsumption)
              sendConsumption(this.get("specialVars").currentConsumption);
          }

          if (this.get("specialVars").gotAccessories && this.get("accessory") && this.get("accessory").specialVars) {
            if (!(this.get("accessory").specialVars instanceof Object))
              this.attributes.accessory.specialVars = JSON.parse(this.attributes.accessory.specialVars);

            if (this.get("accessory").specialVars.currentConsumption)
              sendConsumption(this.get("accessory").specialVars.currentConsumption);
          }
        }
      })
    });

    var collectionItemModel = genericCollectionItem.Model;
    var collectionModel = Backbone.Collection.extend({
      model: collectionItemModel
    });

    var touchScreen = _.extend({}, genericCollectionSection, {

      Views: {
        titleBar: genericCollectionSection.Views.titleBar.extend(),
        content: genericCollectionSection.Views.content.extend({
          template: "application/wizard/sections/genericCollectionSection/collectionWithInfo",
          events: _.extend(_.extend({}, genericCollectionSection.Views.content.prototype.events), {
            "click .toggleInfoButton": "toggleInfos"
          }),

          toggleInfos: function(e) {
            return genericCollectionSection.Views.content.prototype.toggleInfos(e, this);
          },

          addItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.addItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              this.insertView(".elements", viewToAdd);
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          duplicateItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.duplicateSelectedItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              this.insertView(".elements", viewToAdd);
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          removeItemButtonClickedEventHandler: function() {
            var elementToRemove = this.model.removeSelectedItem();
            var viewToRemove = this.getView(function(view) {
              return (elementToRemove === view.model);
            });
            if (viewToRemove) {
              viewToRemove.$el.remove();
              this.model.sortItems();
            }
          },

          beforeRender: function() {
            var collection = this.model.get("collection"),
              collectionLength = collection.models.length;
            var collectionItemView = genericCollectionItem.View;
            var i = 0;

            for (i = 0; i < collectionLength; i++)
              this.insertView(".elements", new collectionItemView({
                model: collection.models[i]
              }));
          },

          afterRender: function() {
            if (!this.model.get("enabled")) {
              this.$el.html("<h4 class='alert'>" + $.i18n._("IDS_W1_9102") + "</h4>");
            } else {
              if (this.model.get("collection").length === 0)
                this.$el.append("<h4 class='alert'>" + $.i18n._("IDS_WAI1001_9018") + "</h4>");
            }
            window.customizeFormElements.call();
          }

        })
      },

      Model: genericCollectionSection.Model.extend({
        defaults: _.extend({
          name: "IDS_WAV8_12",
          collectionEventAggregator: _.extend({}, Backbone.Events),
          infoQuote: "IDS_WGENTT_000035"
        }, genericCollectionSection.Model.prototype.defaults),

        initialize: function() {
          genericCollectionSection.Model.prototype.initialize.apply(this);
          var that = this;
          var collection;
          var oldCollection, i = 0;

          this.get("collectionEventAggregator").unbind("render:requested", this.renderRequestedEventHandler);
          this.get("collectionEventAggregator").bind("render:requested", this.renderRequestedEventHandler, this);

          this.get("collectionEventAggregator").unbind("selectedItem:changed", this.selectedItemChangedEventHandler);
          this.get("collectionEventAggregator").bind("selectedItem:changed", this.selectedItemChangedEventHandler, this);

          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          BticinoS4B.Instances.Models.ApplicationModel.bind("change:filterId", this.systemFilterUpdatedEventHandler, this);

          window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);

          if (this.get("collection")) {
            oldCollection = this.get("collection");

            if (oldCollection.models)
              oldCollection = oldCollection.models;
          }

          this.set("collection", new collectionModel());
          collection = this.get("collection");

          this.systemFilterUpdatedEventHandler();

          if (oldCollection) {
            for (i = 0; i < oldCollection.length; i++) {
              if (!oldCollection[i].attributes)
                this.addItem(_.extend({
                  collectionEventAggregator: this.get("collectionEventAggregator")
                }, oldCollection[i]));
              else
                collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
            }
          }

          if (collection.length < this.get("minItem"))
            this.addItem();

          this.sortItems();

        },

        resetCollection: function() {
          this.set("collection", new collectionModel());
        },

        systemFilterUpdatedEventHandler: function() {
          var currentFilterId = this.get("filterId");
          var newFilterId = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

          if ((newFilterId === -1) || (newFilterId === 1) || (newFilterId === 2)) //If there's no DS
          {
            this.resetCollection();
            this.set("enabled", false);
          } else {
            if (
              ((currentFilterId === 3) || (currentFilterId === 4) || (currentFilterId === 5)) &&
              ((newFilterId === 3) || (newFilterId === 4) || (newFilterId === 5))
            ) {} else {
              this.resetCollection();
            }
            this.set("enabled", true);
          }
          this.set("filterId", newFilterId);
          this.trigger("render:requested");
          this.trigger("updateViews");
        },

        lengthsCommunicationRequested: function() {
          if (this.get("collection"))
            this.get("zoneEventAggregator").trigger("touchScreen:changed", this.get("collection").models.length);
          else
            this.get("zoneEventAggregator").trigger("touchScreen:changed", 0);
        },

        isPossibleToAdd: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length,
            canProceed = (collectionLength + 1) <= 9;

          return canProceed;
        },

        addItem: function(itemModel) {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var defaultItem;

          if (this.isPossibleToAdd()) {
            var collectionItemModel = genericCollectionItem.Model;

            if (itemModel)
              defaultItem = new collectionItemModel(itemModel);
            else
              defaultItem = new collectionItemModel({
                number: this.getNewNumber(),
                collectionEventAggregator: this.get("collectionEventAggregator")
              });

            var itemsToAdd = [];
            itemsToAdd.push(defaultItem);
            if (genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd)) {
              defaultItem.set("selected", true);
              this.trigger("updateViews", this.get("collection").length);

              //Trigger event for zone validation
              this.trigger("item:added");

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              BticinoS4B.Instances.Models.ApplicationModel.set("touchScreenCollectionLength", this.get("collection").length);
              return defaultItem;
            }
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        duplicateItem: function(modelToDuplicate) {
          var collectionItemModel = genericCollectionItem.Model;
          var itemNumber = this.getNewNumber();
          var collection = this.get("collection"),
            collectionLength = collection.length;

          if (this.isPossibleToAdd()) {
            if (modelToDuplicate)
            {
              modelToDuplicate = new collectionItemModel(modelToDuplicate.attributes);

              modelToDuplicate.set("number", itemNumber);
              this.get("collection").add(modelToDuplicate);
              this.trigger("updateViews", this.get("collection").length);

              //Trigger event for zone validation
              this.trigger("item:added");
              this.trigger("render:requested");

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              BticinoS4B.Instances.Models.ApplicationModel.set("touchScreenCollectionLength", this.get("collection").length);
              return modelToDuplicate;
            } else {
              return false;
            }
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        sortItems: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var i = 0;

          for (i = 0; i < collectionLength; i++) {
            collection.models[i].set("number", (i + 1));
            if (i === (collectionLength - 1))
              collection.models[i].set("selected", true);
          }
        },

        removeItem: function(modelToRemove, _silent) {
          var silent = false;

          if (_silent)
            silent = _silent;

          if (!modelToRemove.get("partOfKit") || silent) {
            if (this.deleteItem(modelToRemove, silent)) {
              this.trigger("updateViews", this.get("collection").length);

              this.sortItems();

              //Trigger event for zone validation
              this.trigger("item:removed");
              this.trigger("render:requested");

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              BticinoS4B.Instances.Models.ApplicationModel.set("touchScreenCollectionLength", this.get("collection").length);

              return modelToRemove;
            }
          } else{
            alert($.i18n._('IDS_W1_9191'));
            return false;
          }
        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.touchScreen = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.touchScreen = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.touchScreen = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.touchScreen = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.touchScreen = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.touchScreen = this;
              break;
          };
          BticinoS4B.Instances.Models.ApplicationModel.set("touchScreen", this);
        },

        deliverCurrent: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
          var extraConsumption = 30; //30 mA of extra consumption
          var mustDeliverExtraConsumption = false;
          var i = 0;

          //Delivering regular consumptions
          for (i = 0; i < collectionLength; i++) {
            if (collection.models[i].get("packageClassId") === "4044")
              mustDeliverExtraConsumption = true;
            collection.models[i].deliverCurrent();
          }

          if (mustDeliverExtraConsumption) {
            if (extraConsumption && extraConsumption !== 0) {
              if (extraConsumption < 0)
                consumptionIndicatorModel.addSupplyCurrent(extraConsumption);
              else
                consumptionIndicatorModel.addCurrentConsumption(extraConsumption);
            }
          }
        }
      }),
      genericCollectionItem: genericCollectionItem
    });

    // Required, return the module for AMD compliance
    return touchScreen;

  });